//by Raymond Chong
import Vue from "vue";
import ProductGrid from "./ProductGrid.vue";
import ProductList from "./ProductList.vue";
import PopupLogin from "./PopupLogin.vue";

Vue.component("product-grid", ProductGrid);
Vue.component("product-list", ProductList);
Vue.component("popup-login", PopupLogin);

